<template>
  <div class="flex main">
    <div class="left-block">
      <!-- <img src="" alt=""> -->
      <UploadImage
        v-show="fileId"
        :width="200"
        :height="200"
        :view="true"
        ref="viewImageRef"
      ></UploadImage>
      <div class="none-data" v-show="!fileId">暂无任何{{ typeStr }}</div>
      <Button type="primary" @click="handleShowModal"
        >上传/管理{{ typeStr }}</Button
      >
    </div>
    <div class="right-block">
      <p>{{ typeStr }}宽度：{{ width }} px</p>
      <p>{{ typeStr }}高度：{{ height }} px</p>
      <p>{{ desc }}</p>
    </div>
    <Modal
      v-model="show"
      title="印章上传"
      :width="900"
      :mask-closable="false"
      :footer-hide="true"
    >
      <div class="main flex">
        <div class="left-block">
          <!-- <img src="" alt=""> -->

          <UploadImage
            :width="200"
            :height="200"
            :maxNumber="1"
            :view="true"
            :maxSize="1"
            ref="uploadImageRef"
            @on-change="onImageChange"
          ></UploadImage>
          <div class="none-data" v-show="!fileId">暂无任何{{ typeStr }}</div>
          <Button type="primary" v-show="!fileId" @click="handleClickUp"
            >上传{{ typeStr }}</Button
          >
          <div v-if="fileId">
            <Button
              type="primary"
              style="margin-right: 10px"
              @click="handleClickResetUp"
              >重新上传</Button
            ><Button type="primary" @click="handleDelete"
              >删除{{ typeStr }}</Button
            >
          </div>
        </div>
        <div class="right-block">
          <p>
            {{ typeStr }}宽度：<InputNumber
              :min="0"
              :max="175"
              v-model="widthVal"
              style="margin-right: 8px"
            ></InputNumber
            >px
          </p>
          <p>
            {{ typeStr }}高度：<InputNumber
              :min="0"
              :max="175"
              v-model="heightVal"
              style="margin-right: 8px"
            ></InputNumber
            >px
          </p>
          <p>{{ desc }}</p>
        </div>
      </div>
      <div class="modal-430-bottom">
        <Button @click="handleCancle">取消</Button>
        <Button type="primary" @click="handleSubmit('formValidate')"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>
<script>
import operationAdmin from '@/request/operationAdmin/index.js';
import UploadImage from '@c/Base/UploadImage.vue'
export default {
  components: {
    UploadImage
  },

  props: {
    actionType: {
      type: String,
      default: 'org'
    },
    id: {
      type: String,
      default: ''
    },
    typeStr: {
      type: String,
      default: '印章'
    },
    desc: {
      type: String,
      default: '设置印章后，印章将被使用到需要打印的文档中！'
    }
  },
  data() {
    return {
      show: false,
      fileId: '',
      fileUrl: '',
      fileType: '', // 1 : 后端返回，2:源文件
      height: '',
      width: '',
      heightVal: 175,
      widthVal: 175
    };
  },
  created() {
    this.getSignet()
  },
  methods: {
    handleCancle() {
      this.show = false
      this.getSignet()
    },
    async handleSubmit() {
      let fileIds = await this.$refs.uploadImageRef.getResult()
      if (fileIds.length == 0) {
        this.$Message.warning('请上传图片');
        return null
      }
      if (!this.widthVal || !this.heightVal) {
        this.$Message.warning('请填写印章宽度和高度');
        return null
      }
      this.saveOrUpdateSignet(fileIds)
    },
    handleDelete() {
      this.deleteOrUpdateSignet()
      // this.fileUrl = ''
      // this.$refs.uploadImageRef.handleClear()
    },
    handleShowModal() {
      this.widthVal = this.width ? this.width : 175
      this.heightVal = this.height ? this.height : 175
      this.show = true
      this.$nextTick(() => {
        this.$refs.uploadImageRef.handleClear()
        this.fileId && this.$refs.uploadImageRef.setIds([this.fileId])
      })
    },
    handleClickUp() {
      this.$refs.uploadImageRef.handleClickBtn()
    },
    handleClickResetUp() {
      this.$refs.uploadImageRef.handleResetUp()
    },
    onImageChange(files) {
      this.fileUrl = files[0]['url']
      this.fileId = files[0]['url']
      this.fileType = files[0]['type']

    },
    // 删除
    async deleteOrUpdateSignet() {

      let res
      this.$Modal.confirm({
        title: '温馨提示',
        content: '是否确定删除？',
        onOk: async () => {
          this.$Spin.show();
          switch (this.actionType) {
            case 'org':
              res = await operationAdmin.deleteOrUpdateSignetForOperation({
                orgId: this.id,
              })
              break;
            case 'school':
              res = await operationAdmin.deleteOrUpdateSignetForOperation({
                orgId: this.id,
              })
              break;
            case 'operation':
              res = await operationAdmin.deleteOrUpdateSignetForOperation({
                orgId: this.id,
              })
              break;
            case 'operationLogo':
              res = await operationAdmin.deleteOrUpdateSignetForOperationLogo()
              break;
          }
          this.$Spin.hide();
          if (res.status == 200) {
            this.show = false
            this.$Message.success('删除成功');
            this.getSignet()
          }
        },
        onCancel: () => {

        }
      });

    },
    async saveOrUpdateSignet(fileIds) {
      let res

      let parameter = {
        orgId: this.id,
        fileId: fileIds.join(','),
        height: this.heightVal,
        width: this.widthVal
      }
      this.$Spin.show();
      switch (this.actionType) {
        case 'org':
          res = await operationAdmin.saveOrUpdateSignetForOperation(parameter)
          break;
        case 'school':
          res = await operationAdmin.saveOrUpdateSignetForOperation(parameter)
          break;
        case 'operation':
          res = await operationAdmin.saveOrUpdateSignetForOperation(parameter)
          break;
        case 'operationLogo':
          res = await operationAdmin.saveOrUpdateSignetForOperationLogo(parameter)
          break;
      }
      this.$Spin.hide();
      if (res.status == 200) {
        this.show = false
        this.$Message.success('修改成功');
        this.getSignet()
      }
    },
    async getSignet() {
      let res
      switch (this.actionType) {
        case 'org':
          res = await operationAdmin.getSignetForOperation({
            orgId: this.id
          })
          break;
        case 'school':
          res = await operationAdmin.getSignetForOperation({
            orgId: this.id
          })

          break;
        case 'operation':
          res = await operationAdmin.getSignetForOperation({
            orgId: this.id
          })
          break;
        case 'operationLogo':
          res = await operationAdmin.getSignetForOperationLogo({
            orgId: this.id
          })
          break;
      }
      if (res.status == 200) {
        let { fileId, height, width } = res.message
        this.fileUrl = ''
        this.fileId = fileId
        this.fileType = 1
        this.height = height
        this.width = width
        this.$refs.uploadImageRef.handleClear()
        fileId && this.$refs.viewImageRef.setIds([fileId])
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.main {
  display: flex;
  .left-block {
    text-align: center;
    margin-right: 30px;
    .none-data {
      margin-bottom: 20px;
      border-radius: 4px;
      background-color: #eee;
      height: 200px;
      width: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 16px;
    }
  }
  .right-block {
    padding-top: 30px;
    p {
      margin-bottom: 15px;
    }
  }
}
</style>
